import type { Route } from '@angular/router';

export const limitReportRoute: Route = {
  path: 'limits',
  loadComponent: () =>
    import('./user-limit-list.component').then(
      (mod) => mod.UserLimitListComponent,
    ),
  children: [
    {
      path: 'preview/:id',
      loadComponent: () =>
        import('./form/user-limit-form.component').then(
          (mod) => mod.UserLimitFormComponent,
        ),
    },
  ],
};

// @NgModule({
//   imports: [
//     CommonModule,
//     RouterModule.forChild(routes),

//     MatProgressBar,

//     TranslocoModule,
//     FontAwesomeModule,

//     ActionButtonModule,
//     UiMatTableModule,
//     PipesModule,

//     UserLimitDomainModule,
//     PageContainerComponent,
//   ],
//   declarations: [UserLimitListComponent],
//   exports: [UserLimitListComponent],
// })
// export class UserLimitListModule {}
